import React from 'react';
import { ScopeConfiguration } from './scopeUtilsLib';
import { ScopeConfigurationDefinition } from './scopeLib';

interface ScopeConfigurationDisplayProps {
  definition: ScopeConfigurationDefinition;
  scopeConfiguration: ScopeConfiguration;
}

const ScopeConfigurationDisplay: React.FC<ScopeConfigurationDisplayProps> = ({
  definition,
  scopeConfiguration,
}) => {
  return definition.render(scopeConfiguration);
};

export default ScopeConfigurationDisplay;
